import { createElement } from 'react';

const SvgCheckSuccess = (props) => (createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 11 8", fill: "none" }, props),
    createElement("path", { d: "M1 3.7L4.15 7 10 1", stroke: "#28B583", strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" })));

export default SvgCheckSuccess;
